import React from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

function MessageIcon({ t, icon, backgroundColor }) {

    const classes = useStyles()

    return (
        <div className={classes.iconContainer} style={backgroundColor && { backgroundColor }}>
            {icon && icon}
        </div>

    )
}

const useStyles = makeStyles((theme) => ({
    iconContainer: {
        padding: 10,
        borderRadius: '50%',
        display: 'flex'
    }
}))

export default withTranslation()(withRouter(MessageIcon))